<div class="rush-main">
  <app-rush-header></app-rush-header>
  <app-rush-tabs [class.hide]="!isTabSelected()" class="content"></app-rush-tabs>
  <app-rush-other-page-content
    [class.hide]="isTabSelected()"
    class="content mt-4 p-1"
  ></app-rush-other-page-content>
  <app-winner-alert
    *ngIf="showRushWinnerResult"
    [show]="showRushWinnerResult"
    [chips]="totalEarning.earned"
    [bonus]="totalEarning.bonus"
    (onEnded)="hideRushWinnerResult()"
    bet="{{ gameResult?.betWinner }}"
  ></app-winner-alert>
</div>
<app-popup
  (onHide)="_rushPopupService.hideAll()"
  [show]="_rushPopupService.showInfo"
  svg="info.svg"
  [title]="_rushPopupService.title"
  >{{ _rushPopupService.message }}</app-popup
>
<app-popup-success
  (onHide)="_rushPopupService.hideAll()"
  [show]="_rushPopupService.showSuccess"
  svg="pot.png"
  [title]="_rushPopupService.title"
  >{{ _rushPopupService.message }}</app-popup-success
>
<app-popup-danger
  (onHide)="_rushPopupService.hideAll()"
  [show]="_rushPopupService.showDanger"
  svg="info.svg"
  [title]="_rushPopupService.title"
  >{{ _rushPopupService.message }}</app-popup-danger
>
<app-chips-alert
  *ngIf="incommingChipsAlert.activate"
  [incommingChipsAlert]="incommingChipsAlert"
  [durationSec]="2"
  (onEnded)="hideChipsAlert()"
></app-chips-alert>
